import BigPicture from 'bigpicture'



const lightview = () => {
  //---------------------------//
  // Gallery LIGHTVIEW
  //---------------------------/
  const gallery = document.querySelectorAll('.wp-block-gallery');

  if( gallery.length > 0 ){
    for (let i = 0; i < gallery.length; i++) {
      gallery[i].addEventListener('click', function (e) {
        e.preventDefault();
        BigPicture({
          el: e.target,
          gallery: '.wp-block-gallery',
          galleryAttribute: 'src'
        })
      })
    }
  }

}

export default lightview;